import { useNavigate } from 'react-router-dom';
import { Button } from 'rsuite';

export const NotFound = () => {
  const navigate = useNavigate();
  const goToHome = () => {
    navigate('/');
  };
  return (
    <div className="not-found-container">
      <div className="cloud-bg"></div>
      <div className="message-box">
        <div className="title">{'Sorry, page not found'}</div>
        <div className="desc">
          {
            'Please use the navigation menu or click the buttons below to access the page.'
          }
        </div>
        <div className="buttons-container">
          <Button
            appearance="primary"
            className="btn to-home"
            onClick={goToHome}
          >
            {'Go To Homepage'}
          </Button>
        </div>
      </div>
    </div>
  );
};
